import { ContentType, Component } from 'contensis-core-api';
import { DuplicateContentTypeTarget } from '~/services';
import ContentTypeHelper from '~/util/content-type/ContentTypeHelper';

export default (
  contentType: ContentType | Component,
  projectId: string,
  target: DuplicateContentTypeTarget | null = null
): ContentType | Component => {
  const ctLanguage =
    'defaultLanguage' in contentType
      ? contentType.defaultLanguage || 'en-GB'
      : 'en-GB';
  const defaultLanguage = target?.defaultLanguage || ctLanguage;

  const { fields } = ContentTypeHelper.transform.TransformLanguageCodes(
    contentType,
    ctLanguage,
    defaultLanguage
  );

  const mappedContentType = {
    ...contentType,
    uuid: undefined,
    id: target?.id || contentType.id,
    name: {
      [defaultLanguage]:
        target?.name || target?.id || contentType.name[ctLanguage],
    },
    description: {
      [defaultLanguage]:
        target?.description || contentType.description?.[ctLanguage],
    },
    defaultLanguage,
    projectId,
    fields,
  } as unknown as ContentType | Component;

  return mappedContentType;
};
